module.exports = __webpack_public_path__ + "img/chongci_ps_02.9a3665f0.jpg";